import React,{useState,useEffect} from "react";
import { Link } from 'react-router-dom';
import { Layout, Menu } from "antd";
import { PoweroffOutlined, UserOutlined } from '@ant-design/icons';

import "../../styles/kernel.scss";

import {userSignOut} from "../../appRedux/actions/Auth";
import {useDispatch, useSelector} from "react-redux";
import {getLogo, isIteDomain} from "../../util/getLogo";

const { Header} = Layout;

const NavBar = () => {
    const dispatch = useDispatch();
    const logoLink = isIteDomain() ? "https://www.iteprevengo.com/" : "https://gestionasst.pe/course-virtual.php";

    return(
        <Header className="navBar" style={{ position: 'fixed', zIndex: 10, width: '100%', background: 'white' }}>
            <a href={logoLink} target={isIteDomain() ? "_blank" : undefined} rel={isIteDomain() ? "noreferrer" : undefined}><div className="logo" style={{ backgroundImage: `url(${getLogo()})` }} /></a>
          
        
        </Header>
    );

}

export default NavBar;